import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=09fdb79c&scoped=true&"
import script from "./ModalHeader.vue?vue&type=script&lang=js&"
export * from "./ModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=09fdb79c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fdb79c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09fdb79c')) {
      api.createRecord('09fdb79c', component.options)
    } else {
      api.reload('09fdb79c', component.options)
    }
    module.hot.accept("./ModalHeader.vue?vue&type=template&id=09fdb79c&scoped=true&", function () {
      api.rerender('09fdb79c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ModalHeader.vue"
export default component.exports